import {sellerConstants } from '../../../_constants/seller.constants';

const initialState = { primaryAdminLoading : true, data: '', error: false, errorText: ''};

export function makePrimaryAdmin(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_ADD_SELLER_ADMIN:
        return {
          primaryAdminLoading: true,
          data: '',
          error: false,
          errorText: ''
        };
      case sellerConstants.ADD_SELLER_ADMIN_SUCCESS:
        return {
          primaryAdminLoading: false,
          data: action.data,
          error: false,
          errorText: ''
        };
      case sellerConstants.ADD_SELLER_ADMIN_ERROR:
        return { 
          primaryAdminLoading: false,
          data: '',
          error: true,
          errorText: action.error
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/sellerAdmin/makePrimaryAdmin.reducer.js